export enum ExternalUrlSectionType {
  Details = 'details',
  Translations = 'translations',
  Visibility = 'visibility'
}
